import { render, staticRenderFns } from "./ProcessTraMaterial.vue?vue&type=template&id=03358dd9&scoped=true"
import script from "./ProcessTraMaterial.vue?vue&type=script&lang=js"
export * from "./ProcessTraMaterial.vue?vue&type=script&lang=js"
import style0 from "./ProcessTraMaterial.vue?vue&type=style&index=0&id=03358dd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03358dd9",
  null
  
)

export default component.exports